(function () {
  var css =
    '[id^="GalleryViewer"]{position:relative}' +
    '.cgn-btn{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:4.4rem;height:4.4rem;border-radius:50%;border:none;background:rgba(255,255,255,.92);box-shadow:0 2px 10px rgba(0,0,0,.2);cursor:pointer;display:flex;align-items:center;justify-content:center;color:#1a1a1a;opacity:1;transition:background .2s ease,transform .1s ease}' +
    '.cgn-btn:hover{background:#fff}' +
    '.cgn-btn:active{transform:translateY(-50%) scale(.94)}' +
    '.cgn-btn svg{width:1.7rem;height:1.7rem;display:block}' +
    '.cgn-btn--prev{left:1.2rem}.cgn-btn--next{right:1.2rem}' +
    '@media screen and (max-width:749px){.cgn-btn{width:3.6rem;height:3.6rem;left:.8rem}.cgn-btn--next{right:.8rem;left:auto}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function initGalleryArrows() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.cgnDone) return;
      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
      if (!viewer || !thumbs) return;
      var thumbButtons = Array.prototype.slice.call(thumbs.querySelectorAll('[data-target] button'));
      if (thumbButtons.length < 2) return;
      gallery.dataset.cgnDone = '1';
      function currentIndex() {
        for (var i = 0; i < thumbButtons.length; i++) {
          if (thumbButtons[i].getAttribute('aria-current') === 'true') return i;
        }
        return 0;
      }
      function go(dir) {
        var i = currentIndex();
        var n = (i + dir + thumbButtons.length) % thumbButtons.length;
        thumbButtons[n].click();
      }
      function makeBtn(cls, label, d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cgn-btn ' + cls;
        b.setAttribute('aria-label', label);
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + d + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return b;
      }
      var prev = makeBtn('cgn-btn--prev', 'Previous image', 'M15 18l-6-6 6-6');
      var next = makeBtn('cgn-btn--next', 'Next image', 'M9 6l6 6-6 6');
      prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
      next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
      viewer.appendChild(prev);
      viewer.appendChild(next);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrows);
  } else {
    initGalleryArrows();
  }
  document.addEventListener('shopify:section:load', initGalleryArrows);
})();
